module.exports = __webpack_public_path__ + "static/img/YB-600H.3e21f35d.png";